import { useDispatch, useSelector } from 'react-redux';

import { me } from 'api/endpoints/user';
import { ENUM_USER_STATUS } from 'constants/enum';
import { setIsAuthenticated, setProfile } from 'store/actions/auth';
import { getCodeJapaneseGovernmentsWith, handleCheckLanguage } from 'utils/helper';

const useUser = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const getMe = async () => {
    try {
      await me(isAuthenticated)
        .then((response) => {
          dispatch(
            setProfile({
              ...response.data,
              municipality_code: response.data?.municipality || '',
              municipality: getCodeJapaneseGovernmentsWith(response.data?.municipality, false) || '',
              lang: handleCheckLanguage(response.data?.municipality),
            })
          );
        })
        .catch(() => {
          dispatch(setIsAuthenticated(null));
        });
    } catch (err) {
      // Handle error
    }
  };

  const checkUserApprove = async () => {
    try {
      await me(isAuthenticated)
        .then((response) => {
          if (response?.data?.status !== ENUM_USER_STATUS.APPROVED) {
            dispatch(setIsAuthenticated(null));
          }
        })
        .catch(() => {
          dispatch(setIsAuthenticated(null));
        });
    } catch (err) {
      // Handle error
    }
  };

  return { getMe, checkUserApprove };
};

export default useUser;
